import { i18n } from '@apps/main/modules/localization/localizationSetup';

import { PremadeTripType } from '../../models';
import type { AIPremadeTripWithOptionalImageUrl } from '../../models';

import type { AIPremadeTripResponse } from './aiService.model';

const { t } = i18n.global;

export function mapResponseToAIPremadeTrip(
  response: AIPremadeTripResponse
): AIPremadeTripWithOptionalImageUrl {
  const description = {
    mainText: response.inspirationalMessage,
    destinations: response.destinations,
  };

  return {
    type: PremadeTripType.AI,
    headline: t('planner.my_trip'),
    description,
    imageUrl:
      response.imageUrl !== null && response.imageUrl.length > 0
        ? response.imageUrl
        : undefined,
  };
}
